import React from 'react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

const AddressStep = ({ formData, set }) => (
  <div className="space-y-4" data-testid="step-address">
    <h3 className="text-xl font-semibold mb-2 text-emerald-800">Registered Address</h3>
    <div>
      <Label htmlFor="physical">Physical Address *</Label>
      <textarea
        id="physical"
        data-testid="physical-address"
        value={formData.physicalAddress}
        onChange={(e) => set('physicalAddress', e.target.value)}
        placeholder="Street, Suburb, City, Province, Postal Code"
        className="mt-1 w-full p-2 border border-gray-300 rounded-md min-h-[80px]"
      />
    </div>
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        id="sameAddress"
        checked={formData.sameAsPhysical}
        onChange={(e) => {
          const checked = e.target.checked;
          set('sameAsPhysical', checked);
          if (checked) set('postalAddress', formData.physicalAddress);
        }}
        className="h-4 w-4 text-emerald-600"
      />
      <Label htmlFor="sameAddress" className="cursor-pointer">
        Postal address same as physical address
      </Label>
    </div>
    {!formData.sameAsPhysical && (
      <div>
        <Label htmlFor="postal">Postal Address</Label>
        <textarea
          id="postal"
          data-testid="postal-address"
          value={formData.postalAddress}
          onChange={(e) => set('postalAddress', e.target.value)}
          className="mt-1 w-full p-2 border border-gray-300 rounded-md min-h-[80px]"
        />
      </div>
    )}
  </div>
);

export default AddressStep;
